import KreateSomethingCarousel from './kreate-something-carousel';

const KreateSomething = () => {
  return (
    <div className="bg-background text-text-primary w-full pb-20 mx-2 my-10 sm:mx-6 max-w-[calc(100%-1rem)] sm:max-w-[calc(100%-3rem)] rounded-3xl">
      <h1 className="text-4xl w-[90%] sm:text-5xl mx-auto font-medium max-w-3xl text-center pt-12 sm:pt-16 mb-8 sm:mb-10 px-4 sm:px-0">
        Kreate something great, with
      </h1>

      <KreateSomethingCarousel />
    </div>
  );
};

export default KreateSomething;
